import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { OnboardingPage } from '../ui';
import actions from '../redux/actions';
import { RootState } from '../redux/store';
import { OperationStatus } from '../types/OperationStatus';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: theme.palette.background.default,
    }
}));

const RegisterApproved = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const { loginToken, loginStatus } = useSelector((state: RootState) => state);

    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(actions.impersonate(loginToken));
        }, 4000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (loginStatus.status === OperationStatus.success) {
            history.push('/complete-profile/personal');
        }
    }, [loginStatus.status]);


    return (
        <OnboardingPage title="Registration Approved">
            <div>
                <Typography sx={{ fontWeight: 600, mb: 1 }}>Your registration has been approved</Typography>
                <Typography sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <CircularProgress size={18} />
                    You will be redirected to your account shortly
                </Typography>
            </div>
        </OnboardingPage>
    );
};

export default RegisterApproved;